<script setup>
import { ref, computed } from "vue"
import { PencilSquareIcon } from '@heroicons/vue/24/solid'
import { PrimaryButton } from "@codinglabsau/ui"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"

const props = defineProps({
  stats: {
    required: true,
  },
  options: {
    required: true,
  }
})

let showDialogue = ref(false)

const emits = defineEmits(['update:stats'])

const computedStats = computed({
  get() {
    return props.stats
  },
  set(value) {
    emits('update:stats', value)
  },
})
</script>

<template>
  <ToolbarButton
    :label="__('Edit Stats')"
    :icon="PencilSquareIcon"
    v-model="showDialogue"
  />
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Edit Stats') }}
    </template>
    <template #description>
      {{ __('Choose which stats to show.') }}
    </template>
    <div>
      <div v-for="stat in options">
        <label class="inline-flex items-center">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 mr-1"
            :value="stat.id"
            name="stats"
            v-model="computedStats"
          />
          <span>{{ stat.label }}</span>
        </label>
      </div>
    </div>
    <PrimaryButton class="mt-2" type="button" @click.prevent="showDialogue = false">{{ __('Done') }}</PrimaryButton>
  </Modal>
</template>
